/**
 * Joins class strings, dropping anything falsy.
 *
 * Forty characters rather than a dependency: `clsx` and `class-variance-authority` both
 * solve problems this console does not have, and a console a dispatcher opens at six in the
 * morning on office hardware pays for every kilobyte of them.
 *
 * It lives in its own file because `react/only-export-components` warns on a module that
 * exports both a component and something else, and every primitive imports this.
 */
export function cx(...parts: (string | false | null | undefined)[]): string {
  return parts.filter(Boolean).join(' ');
}
